import { Routes } from "@angular/router";

export const routes: Routes = [
  // { path: "", redirectTo: "play", pathMatch: "full" },
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./play/play.component").then((m) => m.PlayComponent),
  },
  // {
  //   path: "howitworks",
  //   pathMatch: "full",
  //   loadComponent: () =>
  //     import("./howitworks/howitworks.component").then(
  //       (m) => m.HowitworksComponent,
  //     ),
  // },
  // {
  //   path: "learnmore",
  //   pathMatch: "full",
  //   loadComponent: () =>
  //     import("./learn/learn.component").then((m) => m.LearnComponent),
  // },
  // {
  //   path: "feedback",
  //   pathMatch: "full",
  //   loadComponent: () =>
  //     import("./feedback/feedback.component").then((m) => m.FeedbackComponent),
  // },
  // { path: "game", redirectTo: "game.eveintel.com", pathMatch: "full" },
  {
    path: "**",
    pathMatch: "full",
    loadComponent: () =>
      import("./under-construction/under-construction.component").then(
        (m) => m.UnderConstructionComponent,
      ),
  },
];
